<template>
  <button
    type="button"
    class="text-gray-600 hover:text-gray-700 active:text-gray-800 size-9 flex items-center justify-center shrink-0 transition-colors disabled:opacity-50 disabled:hover:text-gray-600 [&_svg]:size-5 [&_svg]:shrink-0"
    :class="shape === 'round'
      ? 'bg-white rounded-full shadow-md border-0 hover:bg-gray-100 active:bg-gray-200'
      : 'bg-white border border-gray-300 rounded-lg hover:bg-gray-100 active:bg-gray-200'"
    :disabled="disabled"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <template v-if="active">
      <slot name="on" />
    </template>
    <template v-else>
      <slot name="off" />
    </template>
    <slot />
  </button>
</template>

<script setup>
defineOptions({
  inheritAttrs: false,
})

defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  shape: {
    type: String,
    default: 'square',
    validator: value => ['square', 'round'].includes(value),
  },
})

defineEmits(['click'])
</script>
